import { SessionHelper } from "app/helpers/sessionHelper";
import { ResponsiveScreenSizes } from "app/utils/const";
import { useEffect, useState } from "react";
import Media from "react-media";
import DesktopRouter from "../DesktopRouter/DesktopRouter";
import MobileRouter from "../MobileRouter/MobileRouter";

type Props = {
  location: any;
};

const RouterMainContent: React.FC<Props> = ({ location }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    setIsAuthenticated(SessionHelper.isAuthenticated());
  }, []);

  // check location changes to update isAuthenticated
  // side effect migration from class component
  useEffect(() => {
    setIsAuthenticated(SessionHelper.isAuthenticated());
  }, [location]);

  return (
    <main
      className={isAuthenticated ? "is-authenticated" : "not-authenticated"}
    >
      {/* DESKTOP */}
      <Media
        query={`(min-width: ${ResponsiveScreenSizes.desktop})`}
        render={() => (
          <div className="main-content__container--centered">
            <DesktopRouter location={location} />
          </div>
        )}
      />
      {/* MOBILE */}
      <Media
        query={`(max-width: ${ResponsiveScreenSizes.mobile})`}
        render={() => <MobileRouter location={location} />}
      />
    </main>
  );
};

export default RouterMainContent;
